import { render } from "./OurStorySection.vue?vue&type=template&id=bdb58d58&scoped=true"
import script from "./OurStorySection.vue?vue&type=script&lang=js"
export * from "./OurStorySection.vue?vue&type=script&lang=js"

import "./OurStorySection.vue?vue&type=style&index=0&id=bdb58d58&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bdb58d58"]])

export default __exports__